module.exports = __webpack_public_path__ + "static/media/icon-cadastral-advisory-002.ce95f0bf.svg";